<template>
  <div class="module-list">
    <div class="module-title">{{data.productName}}</div>
    <div class="module-desp">{{data.remark ? data.remark : ''}}</div>
    <ul class="module-input">
      <li>
        <div class="input-title">{{ data.productType === 1 ? '开启门店数' : '开启设备数'}}</div>
        <vue-numeric-input class="cube-input" v-model="storeNumber" :controls="false" :precision="0" :min="1"></vue-numeric-input>
      </li>
      <li>
        <div class="input-title">使用时长(月)</div>
        <vue-numeric-input class="cube-input" v-model="duration" :controls="false" :precision="0" :min="1" :max="60"></vue-numeric-input>
      </li>
    </ul>
    <Button slot="button" class="moudle-add-btn" @click="addToOrder" :disabled="data.hasSelect === 1">添加</Button>
  </div>
</template>

<script>
import { Style, Button, Toast } from 'cube-ui';
import VueNumericInput from 'vue-numeric-input';

export default {
  components: {
    VueNumericInput,
    Button
  },
  props: {
    data: {
      default() {
        return {}
      },
      type: Object
    }
  },
  created() {
    // console.log(this.data.storeNumber)
    // this.data.storeNumber ? this.storeNumber = this.data.storeNumber : this.storeNumber = null;
    // this.data.duration ? this.duration = this.data.duration : this.duration = null;
  },
  data() {
    return {
      storeNumber: this.data.storeNumber,
      duration: this.data.duration,
    }
  },
  methods: {
    addToOrder() {
      if(this.storeNumber == null || this.duration == null) {
        this.showToast('请填写必要信息');
        return false;
      }
      
      this.$emit('select',{
        storeNumber: this.storeNumber,
        duration: this.duration,
      });
    },
    showToast(text) {
      const toast = this.$createToast({
        txt: text,
        type: 'error'
      });
      toast.show();
    }
  },
  watch: {
    data(nval) {
      nval.storeNumber == undefined ? this.storeNumber = null : this.storeNumber = nval.storeNumber;
      nval.duration == undefined ? this.duration = null : this.duration = nval.duration;
    }
  }
}
</script>


<style lang="scss" scoped>
.module-list {
  width: 92%; 
  min-height: 100px;
  background: #fff;
  padding: 20px 4%;
  .module-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .module-desp {
    font-size: 14px;
    color: #666;
    line-height: 22px;
    margin-bottom: 15px;
  }
  .module-input {
    display: flex;
    justify-content: space-between;
    > li {
      width: 45%;
      .input-title {
        font-size: 14px;
        color: #666;
        margin-bottom: 10px;
      }
    }
  }
  .moudle-add-btn {
    margin-top: 15px;
    height: 45px;
  }
}
</style>

<style lang="scss">
.module-list {
  .cube-input {
    width: 100;
    height: 45px;
    .numeric-input {
      width: 100%;
      height: 45px;
      background: #F7F7F7;
      padding-right: 40px;
      border-color: #E6E6E6;
      outline: none;
      -webkit-appearance: none;
    }
  }
}
</style>


